module.exports = __webpack_public_path__ + "static/media/cake_icon_no_active.a246ff92.svg";